import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María F.',
  role: 'Buenos Aires',
  text: 'Antes pasaba horas buscando material. Ahora entro al aula tranquila. Mis alumnos participan más y yo recuperé mi tiempo.'
}, {
  name: 'Roberto S.',
  role: 'Córdoba',
  text: 'Las clases están tan bien armadas que los chicos entienden conceptos que antes les costaban. Es como tener un asistente experto.'
}, {
  name: 'Laura G.',
  role: 'Rosario',
  text: 'No tengo que improvisar más. Cada clase tiene actividades que realmente funcionan con adolescentes. Vale cada peso.'
}, {
  name: 'Carlos M.',
  role: 'Mendoza',
  text: 'Llevo 20 años enseñando y este es el mejor material que encontré. Completo, claro y pensado para el aula argentina.'
}, {
  name: 'Patricia R.',
  role: 'Tucumán',
  text: 'Recuperé mis noches y fines de semana. Ya no me llevo trabajo a casa porque todo está resuelto.'
}];
export function TestimonialsSection() {
  return <section className="py-14 bg-amber-50" data-id="element-261">
      <div className="container mx-auto px-4" data-id="element-262">
        <div className="text-center mb-8" data-id="element-263">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-1" data-id="element-264">
            Lo que dicen otros docentes
          </h2>
          <div className="flex items-center justify-center gap-1 mt-2" data-id="element-265">
            {[1, 2, 3, 4, 5].map(s => <Star key={s} className="h-4 w-4 fill-amber-500 text-amber-500" data-id="element-266" />)}
            <span className="text-sm text-slate-500 ml-2" data-id="element-267">
              +200 docentes satisfechos
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 max-w-6xl mx-auto" data-id="element-268">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-4 rounded-xl border border-amber-200 shadow-sm flex flex-col gap-3" data-id="element-269">
              <div className="flex gap-0.5" data-id="element-270">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="h-3 w-3 fill-amber-500 text-amber-500" data-id="element-271" />)}
              </div>
              <p className="text-slate-700 text-sm italic flex-1" data-id="element-272">"{t.text}"</p>
              <div className="border-t border-amber-100 pt-2" data-id="element-273">
                <p className="font-bold text-slate-900 text-sm" data-id="element-274">{t.name}</p>
                <p className="text-xs text-slate-400" data-id="element-275">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}